// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"22":"chunk-[request][index]","245":"notfound"}[chunkId] + "-legacy." + {"22":"e971cd55","245":"6f602b77"}[chunkId] + ".js";
};